import { render, staticRenderFns } from "./InsertOrder.vue?vue&type=template&id=04d513a7&scoped=true"
import script from "./InsertOrder.vue?vue&type=script&lang=js"
export * from "./InsertOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d513a7",
  null
  
)

export default component.exports